<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<!-- Navigation  isLoggedIn-->
@if(isLoggedIn && usr.id !== 0){
  <!-- Columna de íconos: queda visible cuando el menú lateral está contraído
       (solo en desktop, en mobile el menú es un overlay). Pinchar en
       cualquier parte reabre el menú completo. -->
  @if (!navigationOpened && !isScreenSmall) {
    <div
      class="sticky top-0 h-screen flex flex-col flex-shrink-0 items-center w-16 py-4 gap-1 dark bg-[#0d1829] print:hidden cursor-pointer overflow-y-auto"
      (click)="toggleNavigation('mainNavigation')">
      <img class="w-8 mb-2" src="assets/logos/ibee-3d-t-256.png">
      <img class="w-6 h-6 rounded-full object-cover mb-2" [class.grayscale]="isMoroso" [src]="usr_img" (error)="onUsrImgError()" [matTooltip]="usr_name" matTooltipPosition="right">
      <!-- Logo de la empresa activa (misma fuente que el menú expandido; los
           handlers load/error quedan solo allá, que sigue montado aunque esté cerrado) -->
      @if (empLogoSrc && !enVistaDominio) {
        <img class="max-w-12 max-h-8 object-contain mb-2" [src]="empLogoVista || empLogoSrc" [alt]="usr.emp?.name"
          [matTooltip]="empTooltip" matTooltipClass="tooltip-pre-line" matTooltipPosition="right">
      }
      <!-- Separador: equivale al que va bajo el dominio en el menú expandido -->
      <div class="w-10 mb-2 border-t border-gray-600"></div>
      @for (item of navigation.default; track item.id) {
        @if (item.icon) {
          <div class="flex items-center justify-center w-10 h-10 rounded-md transition-colors"
            [ngClass]="isActiveGroup(item) ? 'bg-[#29AFD2]/20' : 'hover:bg-white/10'"
            [matTooltip]="item.title" matTooltipPosition="right"
            (click)="$event.stopPropagation(); onCompactIconClick(item)">
            <mat-icon class="icon-size-5" [ngClass]="isActiveGroup(item) ? 'text-[#29AFD2]' : 'text-white'" [svgIcon]="item.icon"></mat-icon>
          </div>
        }
      }
      <!-- Separador: equivale al que va sobre el logo del pie en el menú expandido -->
      <div class="w-10 mt-2 border-t border-gray-600"></div>
      <img class="w-8 mt-2" src="assets/logos/colibri2-t-80.png">
      <!-- En el consolidado del dominio (dbg-dom): número del dominio y su nombre en el tooltip -->
      @if (enVistaDominio) {
        <span class="text-[10px] text-violet-300 mt-0.5" [matTooltip]="domTooltip" matTooltipPosition="right">#{{usr?.dom?.id}}</span>
      } @else {
        <span class="text-[10px] text-violet-300 mt-0.5" [matTooltip]="usr?.emp?.name" matTooltipPosition="right">#{{usr?.kemp}}</span>
      }
    </div>
  }
  <fuse-vertical-navigation class="dark bg-[#0d1829] print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigation.default" [opened]="!isScreenSmall"
    (openedChanged)="onNavigationOpenedChanged($event)" (click)="onNavItemClick($event)">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <div class="flex flex-row items-center justify-center w-full pt-4">
        <!-- Logo -->
        <div class="flex flex-row items-center gap-2">
          <img class="w-[72px]" src="assets/logos/ibee-3d-t-256.png">
          <div class="flex flex-col leading-none">
            <span style="color: #24B4D5; font-family: 'Bauhaus Std', sans-serif; font-size: 1.875rem; font-weight: 500;">Amazing</span>
            <span style="color: #24B4D5; font-family: 'Bauhaus Std', sans-serif; font-size: 1.875rem; font-weight: 500;">PRP</span>
          </div>
        </div>
        <!-- Components -->
        <!-- <div class="flex items-center ml-auto">
        <notifications></notifications>

      </div> -->
    </div>
    <!-- User -->
    <div class="flex flex-col items-center w-full p-4">

      @if(isLoggedIn){
        <!-- Nombre y correo del usuario: en el tooltip de su foto -->
        <div class="relative w-24 h-24" [matTooltip]="usrTooltip"
          matTooltipClass="tooltip-pre-line" matTooltipPosition="right">
          <img class="w-full h-full rounded-full object-cover" [class.grayscale]="isMoroso" [src]="usr_img" (error)="onUsrImgError()">

        </div>
        <div class="flex flex-col items-center justify-center w-full mt-4">
          <!-- Empresa: su logo (EMP.LOGO → assets) con nombre/RUT/dominio en el
               tooltip; sin logo, cae al nombre + RUT en texto como antes.
               En el tablero consolidado del dominio (ger/dbg-dom) no hay empresa: sin logo. -->
          @if (enVistaDominio) {
            <!-- Vista Holding (ger/dbg-hol, ger/dbg-dom): sin logo ni texto de empresa. -->
          } @else if (empLogoSrc) {
            <div class="flex justify-center w-full mt-1">
              <!-- tooltip en un envoltorio del ANCHO DEL LOGO (no del menú): así sale pegado a él -->
              <span class="inline-flex" [matTooltip]="empTooltip"
                matTooltipClass="tooltip-pre-line" matTooltipPosition="right">
              <!-- Vista del menú: recortada y con los casi-negros aclarados a gris (sin placa) -->
              <img class="max-h-14 max-w-44 object-contain" [src]="empLogoVista || empLogoSrc"
                (load)="onEmpLogoLoad()" (error)="onEmpLogoError()" [alt]="usr.emp.name">
              </span>
            </div>
          } @else {
            @if(usr.emp.name !== '*** NO DEF ***' ){
              <div
                class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-sm leading-normal font-medium text-secondary text-white">
                {{usr.emp.name}}
              </div>
            }
            @if(usr.emp.rutt !== '*** NO DEF ***' ){
              <div
                class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-gray-400 ">
                {{formatRut}}
              </div>
            }
          }

          <!-- Dominio de la empresa (EMP.KDOM); el 1 ('*') es "sin dominio" y no se muestra.
               Solo visible para usuarios tipo DOM. -->
          @if(esDom && usr.dom?.name && usr.dom.id !== 1 && usr.dom.name !== '*** NO DEF ***' ){
            <!-- Holding: aspecto de label (sin borde/fondo), sigue abriendo el selector (onDomClick) -->
            <button type="button" matTooltip="Holding" (click)="onDomClick()"
              class="max-w-full mt-[5mm] px-1 bg-transparent border-0 cursor-pointer text-[#29AFD2] text-xs font-medium hover:underline focus:outline-none">
              <span class="block whitespace-nowrap text-ellipsis overflow-hidden">
                {{usr.dom.name === 'AMAZING INNOVATION SOFTWARE SPA' ? 'AMAZING IA' : usr.dom.name}}
              </span>
            </button>
          }
          <!-- Separador (copia del de arriba del logo del pie); va siempre, haya dominio o no -->
          <div class="w-full mt-4 border-t border-gray-600"></div>
        </div>
      }

    </div>
  </ng-container>
  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationContentFooter>
    @if(isMoroso){
      <div class="px-4 py-3 mx-4 mt-2 text-red-500 text-center text-sm leading-tight border border-red-500/30 bg-red-500/10 rounded-md shadow-sm">
        Esta cuenta está temporalmente fuera de servicio por pago pendiente superior a 30 días. Se reestablece sobre su normalización.
      </div>
    }
    <div class="flex flex-col flex-0 items-center px-4 mt-2 mb-4">
      <div class="w-full border-t border-gray-600"></div>
      <a href="https://amazingia.cl/" target="_blank" class="mt-2 hover:opacity-80">
        <img src="assets/logos/logo-marca-ia.png" class="max-w-32">
      </a>
      @if (enVistaDominio) {
        <span class="text-xs mt-1 text-violet-300" [matTooltip]="domTooltip">#{{usr?.dom?.id}}</span>
      } @else {
        <span class="text-xs mt-1 text-violet-300">#{{usr?.kemp}}</span>
      }
      <!-- Indicador de tamaño de pantalla (breakpoint activo) -->
      <span class="flex flex-col items-center text-[10px] tabular-nums text-gray-600 select-none mt-1 leading-tight">
        <span>
          <span class="inline sm:hidden">xs</span>
          <span class="hidden sm:inline md:hidden">sm</span>
          <span class="hidden md:inline lg:hidden">md</span>
          <span class="hidden lg:inline xl:hidden">lg</span>
          <span class="hidden xl:inline 2xl:hidden">xl</span>
          <span class="hidden 2xl:inline">2xl</span>
        </span>
        <span>{{ winWidth }}px</span>
      </span>
    </div>
  </ng-container>
</fuse-vertical-navigation>

}

<!-- Wrapper -->
@if(true){
  <div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    @if (!isClientesRoute) {
      <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- "Amazing PRP / <módulo>" siempre, con el menú abierto o contraído -->
        <div class="flex items-center justify-center gap-1.5 svg-with-bauhaus">
            <span style="color: #24B4D5; font-family: 'Bauhaus Std', sans-serif; font-size: 1.6875rem; font-weight: 500; white-space: nowrap;">Amazing PRP</span>
            @if (moduleName) {
              <span style="color: #24B4D5; font-family: 'Bauhaus Std', sans-serif; font-size: 1.6875rem; font-weight: 500; white-space: nowrap;">/ {{moduleName | moduleTitle}}</span>
            }
        </div>
        <!-- Components -->
        <!-- Otros usuarios de la empresa en línea: a continuación del título
             "Amazing PRP / módulo", separados 1 cm -->
        @if (presenceError || enLinea.length) {
          <div class="flex items-center gap-1.5 ml-[1cm] min-w-0 overflow-hidden">
            @if (presenceError) {
              <mat-icon class="icon-size-5 text-amber-400" aria-label="No se pudo consultar usuarios en línea"
                [matTooltip]="presenceErrorMessage" matTooltipPosition="below">cloud_off</mat-icon>
            }
            @for (u of enLinea; track trackEnLinea($index, u)) {
              <img class="w-8 h-8 flex-shrink-0 rounded-full object-cover" [src]="u.img" (error)="onEnLineaImgError(u)"
                [matTooltip]="tooltipEnLinea(u)" matTooltipPosition="below" matTooltipClass="tooltip-pre-line">
            }
          </div>
        }
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
          @if(comprasPendientes > 0) {
            <button class="flex items-center gap-1.5 text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap" style="background-color:#f97316" (click)="irAComprasPendientes()"
              matTooltip="Facturas afectas (33) y exentas (34) de compra pendientes de Acuse de Recibo">
              <mat-icon class="icon-size-4" style="color:#fff7ed">receipt_long</mat-icon>
              <span>Facturas pendientes de Acuse de Recibo</span>
              <span class="flex items-center justify-center min-w-[18px] h-[18px] bg-white rounded-full text-[11px] font-bold px-1" style="color:#f97316">{{ comprasPendientes }}</span>
            </button>
          }
          @if(fevVencidos !== 0) {
            <button class="flex items-center gap-1.5 text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap animate-pulse" style="background-color:#e8354a" (click)="irAFevProy()">
              <mat-icon class="icon-size-4" style="color:#facc15">warning</mat-icon>
              <span>Flujos de caja proyectados vencidos</span>
              <span class="flex items-center justify-center min-w-[18px] h-[18px] bg-white rounded-full text-[11px] font-bold px-1" style="color:#e8354a">{{ fevVencidos }}</span>
            </button>
          }
          <div class="text-violet-500">
            {{ahora | date: 'dd/MM/yy HH:mm:ss'}}
          </div>
          <div class="text-red-500">
            U.F: {{ uf | currency : "CLP" : "$ ":"1.2-2" }}
          </div>

          <!--             <button class="lg:hidden" mat-icon-button (click)="quickChat.toggle()">
          <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
        </button> -->
      </div>
      <!-- <mat-icon
      class="pl-2 icon-size-5 sm:text-red-500 md:text-violet-500 lg:text-blue-500 xl:text-lime-500"
      [svgIcon]="'heroicons_solid:tv'">
    </mat-icon> -->
  </div>
    }

<!-- Content -->
<div class="flex flex-col flex-auto">
  <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
  Otherwise, layout changes won't be registered and the view won't be updated! -->
  @if (!isMoroso) {
    <router-outlet></router-outlet>
  }

  @if(isMoroso){
    <div class="flex flex-col items-center justify-center flex-auto w-full h-full text-secondary opacity-50 mt-32">
      <mat-icon class="icon-size-24 mb-4" [svgIcon]="'heroicons_outline:shield-exclamation'"></mat-icon>
      <div class="text-3xl font-bold tracking-tight">Acceso Restringido</div>
      <div class="text-lg mt-2">Por favor, regularice su situación para continuar.</div>
    </div>
  }
</div>

<!-- Footer -->
<!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
<span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
</div>-->

</div>

}

<!-- Quick chat -->
@if(false){
  <quick-chat #quickChat="quickChat"></quick-chat>
}
